import React from "react";
import PropTypes from "prop-types";

import TruncateText from "react/views/generic/TruncateText";
import DetailViewHeader from "react/views/detailView/DetailViewHeader";
import DetailViewTitle from "react/views/detailView/DetailViewTitle";
import DetailViewSubtitle from "react/views/detailView/DetailViewSubtitle";
import ScrollableText from "react/views/generic/ScrollableText";
import SimilarTitlesEventTypes from "data/types/SimilarTitlesEventTypes";
import DetailsFooter from "react/card/DetailsFooter";
import { ReasoningLabel } from "react/views/generic/ReasoningLabel";
import { DetailsBookJacket } from "react/views/bookJacket/BookJacket";
import ContentTitle from 'react/views/generic/ContentTitle';
import OtsContainer from 'react/containers/OtsContainer';

import "./titleDetails.less";

// Why are we using a linear-gradient with no actual gradient to get a background color?
// https://css-tricks.com/tinted-images-multiple-backgrounds/
const backgroundGradient = "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))";

const TitleDetails = (props) => {
	const backgroundImage = `${backgroundGradient}, url(${props.bookJacket})`;
	let isOtsEnabled = props.otsEnabled;
	const scrollableTextLines = isOtsEnabled ? 4 : 6;
	const reasoningClass = isOtsEnabled ?  "title-details-ots-reasoning" : "title-details-reasoning";

	return (
		<div className="card-details">
			<div className="title-details-header">
				<div className="jacket-background" style={{ backgroundImage }}>
					<div className="book-jacket-container">
						<DetailsBookJacket image={props.bookJacket} title={props.title} />
					</div>
				</div>
			</div>
			<div className="title-details-body">
				<DetailViewHeader>
					<DetailViewTitle title={props.title} featureType={SimilarTitlesEventTypes.SIMILARTITLE_DETAILVIEWNAME_CLICKED} uniqueId={props.uniqueId} catalogLink={props.catalogLink}>
						<ContentTitle numLines={2}>{props.title}</ContentTitle>
					</DetailViewTitle>
					<DetailViewSubtitle title={props.author}>
						<TruncateText line={1} truncateText="..." text={`${props.author}`} />
					</DetailViewSubtitle>
					<OtsContainer item={{uniqueId: props.uniqueId, catalogLink: props.catalogLink}} otsEnabled={isOtsEnabled} 
						otsFindItEvent={SimilarTitlesEventTypes.SIMILARTITLE_FINDIT_CLICKED} 
						otsClickEvent={SimilarTitlesEventTypes.SIMILARTITLE_AVAILABILITY_CLICKED}
						loggingDestId={props.uniqueId}/>
				</DetailViewHeader>
				<div className={reasoningClass}>
					<ReasoningLabel featureName={"title"} />
					<ScrollableText line={scrollableTextLines}>{props.reason}</ScrollableText>
				</div>
			</div>
			<DetailsFooter
				featureType={SimilarTitlesEventTypes.SIMILARTITLE_FINDIT_CLICKED}
				uniqueId={props.uniqueId}
				catalogLink={props.catalogLink}
				linkToNovelist={props.linkToNovelist}
				pLinkFeatureType={SimilarTitlesEventTypes.SIMILARTITLE_NOVELIST_CLICKED}
				pLinkDestId={props.uniqueId}
				activeTitleUi={props.activeTitleUi}
			/>
		</div>
	);
};

TitleDetails.propTypes = {
	bookJacket: PropTypes.string,
	title: PropTypes.string.isRequired,
	uniqueId: PropTypes.string.isRequired,
	author: PropTypes.string.isRequired,
	activeTitleUi: PropTypes.string.isRequired,
	reason: PropTypes.string,
	catalogLink: PropTypes.object,
	linkToNovelist: PropTypes.string,
	otsEnabled: PropTypes.bool,
};

export default TitleDetails;



// WEBPACK FOOTER //
// ./src/react/views/titleDetails/TitleDetails.jsx